export * from "./base-crud.component";
